<template>
  <b-card v-if="surveyRevision" class="survey-revision-card">
    <div class="d-flex flex-column h-100">
      <div class="row align-items-start no-gutters mb-0">
        <div class="col">
          <font-awesome-icon :icon="['fal', 'comment-exclamation']" size="lg" />
          <b-link :to="{ name: to, params: { id: surveyRevision.SurveyRevisionId } }">
            <h6 class="mb-1 d-inline">
              <u>{{ $t("Webportal.Actions.SurveyRevision") }} #{{ surveyRevision.SurveyRevisionVisibleId }}</u>
            </h6>
          </b-link>

          <div class="mt-auto d-flex flex-wrap pt-1 pb-1">
            <b-badge v-if="surveyRevision.HasRemarks || surveyRevision.HasAttachments"
              class="survey-revision-item font-weight-normal" variant="secondary" pill>
              <font-awesome-icon :icon="['far', 'poll-h']" /> {{ $t("Webportal.Actions.SurveyRevision.General") }}
            </b-badge>
            <b-badge v-for="(question, index) in surveyRevision.Questions" :key="question.QuestionNumber"
              class="survey-revision-item font-weight-normal" variant="secondary" pill
              v-b-tooltip.hover.nofade="toolTipDelay" :title="`${question.QuestionNumber} ${question.QuestionText}`">
              <font-awesome-icon :icon="['far', 'question-circle']" />
              {{ question.QuestionNumber ? question.QuestionNumber : `#${index + 1}` }}
            </b-badge>
          </div>
        </div>
        <div class="col-auto pl-2">
          <b-badge class="survey-revision-item font-weight-normal d-block" variant="primary" pill>
            <font-awesome-icon :icon="['far', getRevisionStatusIcon(surveyRevision.StatusId)]" />
            {{ getRevisionStatusText(surveyRevision.StatusId) }}
          </b-badge>
          <b-badge v-if="surveyRevision.NeedsTranslation" class="survey-revision-item font-weight-normal d-block"
            variant="primary" pill>
            <font-awesome-icon v-if="surveyRevision.IsTranslated" :icon="['far', 'check-circle']" />
            <font-awesome-icon v-else :icon="['far', 'circle']" />
            {{ $t('Webportal.Translated') }}
          </b-badge>
        </div>
      </div>

      <small class="mt-auto text-muted border-top pt-1">
        {{ getRevisionLastUpdatedText(surveyRevision) }}
      </small>
    </div>
  </b-card>
</template>

<script>
import AppConfig from '@/mixins/AppConfig';
import SurveyRevisionMixin from "@/mixins/SurveyRevisionMixin";

export default {
  name: "SurveyRevisionCard",

  mixins: [AppConfig, SurveyRevisionMixin],

  props: {
    surveyRevision: null,
    to: { default: "SurveyRevision" },
  },
};
</script>
